/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Actions_LogoutInputs */

const nl_common_actions_logout = /** @type {(inputs: Common_Actions_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitloggen`)
};

/**

* @param {Common_Actions_LogoutInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_actions_logout = /** @type {((inputs?: Common_Actions_LogoutInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Actions_LogoutInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_actions_logout(inputs)
});
export { common_actions_logout as "common.actions.logout" }